import React, { Fragment } from "react";
import { useLanguage } from "../context/LanguageContext";
import favicon from "../../assets/favicon.png";

const Title = () => {
  const activeLanguage = useLanguage();
  return (
    <Fragment>
      <h1 className="project__title">
        {activeLanguage.facebookAdsCalculator.title}{" "}
        <img src={favicon} alt="logo symbol" className="project__favicon" />
      </h1>
    </Fragment>
  );
};

export default Title;
